module.exports = __webpack_public_path__ + "static/media/collage2_2_768.8851f67c.png";